import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import logo from "../images/logo.png"
import burger_menu from "../images/icons/burger-menu.svg"
import SocialIcons from "../components/socialIcons"
import LangSwitcher from "../components/langSwitcher"
import StoreButtons from "../components/storeButtons"
import { css } from "@emotion/react"

const Header = ({ siteTitle, lang, globals }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  return (
    <header className="w-full fixed z-30">
      <div className="py-4 px-3 rounded-b-3xl shadow-lg  bg-white shadow-gray-300   md:rounded-none md:shadow-none">
        <div className="container m-auto flex justify-between align-middle items-center lg:px-32">
          <div className="hidden w-2/5 lg:flex lg:items-center">
            <span
              css={cssFollow}
              className="text-base font-semibold font-sans mr-3"
            >
              {globals?.data?.follow_us}
            </span>
            <SocialIcons isDark={true} small={true} />
          </div>
          <div className="flex-1 flex justify-center">
            <Link to={lang === "en-us" ? "/" : `/${lang}/`} className="">
              <img src={logo} alt={siteTitle} className="w-32 mb-0" />
            </Link>
          </div>
          <div className="hidden w-2/5  lg:block">
            <div className="flex justify-end">
              <StoreButtons globals={globals} small={true} />
              <nav>
                <ol className="flex justify-end items-center h-full">
                  <li className="mx-2 p-2">
                    <Link to={lang === "en-us" ? "/blog" : `/${lang}/blog`}>
                      Blog
                    </Link>
                  </li>
                  {/* <li className=" px-2 ">
                    <LangSwitcher lang={lang} />
                  </li> */}
                </ol>
              </nav>
            </div>
          </div>
          <div className="flex-1 flex justify-end lg:hidden">
            <button
              aria-label="open menu"
              className="mr-5"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <img src={burger_menu} alt={siteTitle} className="" />
            </button>
          </div>
        </div>
        {menuOpen && (
          <ul className="text-center lg:hidden">
            {/* <li className="py-6 px-5 my-2 font-sans font-bold text-2xl border-t">
              <Link to={lang === "en-us" ? "/" : `/${lang}/`}>Home</Link>
            </li> */}
            <li className="py-6 px-5 my-2 font-sans font-bold text-2xl border-t">
              <Link to={lang === "en-us" ? "/blog" : `/${lang}/blog`}>
                Blog
              </Link>
            </li>
            {/* <li className="pt-6 px-5 my-2 font-sans flex justify-center lg:justify-end items-center border-t">
              <LangSwitcher lang={lang} />
            </li> */}
          </ul>
        )}
      </div>
    </header>
  )
}

const cssFollow = css`
  background: linear-gradient(
    90deg,
    #ff3891 1.68%,
    #ffbf04 95.67%,
    #ffa503 191.43%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`

Header.propTypes = {
  siteTitle: PropTypes.string,
  lang: PropTypes.string,
  globals: PropTypes.object,
}

export default Header
